import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineArrowRight } from "react-icons/ai";
import { API, graphqlOperation } from "aws-amplify";
import { listSpotJDS } from "../../graphql/queries";

const SpotPlusCampaign = () => {
  const [jobs, setJobs] = useState([]);
  const [nextToken, setNextToken] = useState(null);
  const [isFetching, setIsFetching] = useState(false); // Prevent multiple calls
  const loaderRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const companyEmail = localStorage.getItem("CompanyEmailID");
    if (companyEmail) {
      fetchJobs(companyEmail);
    }
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && nextToken && !isFetching) {
          const companyEmail = localStorage.getItem("CompanyEmailID");
          if (companyEmail) {
            fetchJobs(companyEmail, nextToken);
          }
        }
      },
      { rootMargin: "100px" }
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, [nextToken, isFetching]);

  const fetchJobs = async (companyEmail, token = null) => {
    if (isFetching) return; // Prevent duplicate fetches
    setIsFetching(true);

    try {
      const response = await API.graphql(
        graphqlOperation(listSpotJDS, {
          filter: {
            companyEmail: { eq: companyEmail },
          },
          nextToken: token,
        })
      );

      console.log("GraphQL response for Spot JDs:", response.data.listSpotJDS.items);

      const jobData = response.data.listSpotJDS || {};
      const items = jobData.items || [];
      const newNextToken = jobData.nextToken;

      // Prevent duplicates by using a Set
      setJobs((prevJobs) => {
        const uniqueJobs = new Map();
        [...prevJobs, ...items].forEach((job) => uniqueJobs.set(job.id, job));
        return Array.from(uniqueJobs.values());
      });

      setNextToken(newNextToken);
    } catch (error) {
      console.error("Error fetching Spot JDs:", error);
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <div className="container mx-auto p-6">
      <div className="shadow-xl rounded-lg h-[100vh] overflow-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-6 px-6 py-4">
          {jobs.map((job) => (
            <div key={job.id} className="bg-white border border-gray-200 rounded-lg shadow-md p-6 flex flex-col justify-between min-h-[20rem] transition-all hover:shadow-lg">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-xl font-semibold text-gray-800">{job.jdName}</h3>
                <p className="text-sm text-gray-500">{new Date(job.createdAt).toLocaleDateString()}</p>
              </div>
              {/* <p className="text-gray-600 text-sm mb-2">
                <strong>Skills:</strong> {job.skills}
              </p> */}
              <p className="text-gray-600 text-sm mb-2">
                <strong>Skills:</strong>
                {job.skills.replace(/[\[\]']/g, "").split(",").slice(0, 3).join(", ")}
              </p>



              <p className="text-gray-600 text-sm mb-2">
                <strong>Location:</strong> {job.location}
              </p>
              <p className="text-gray-500 text-sm italic truncate">
                {job.summary}
              </p>
              <div className="flex justify-between items-center mt-6">
                <button
                  onClick={() => navigate(`/job/${job.id}`)}
                  className="bg-gradient-to-r from-blue-600 to-blue-800 text-white font-semibold px-5 py-2.5 rounded-full flex items-center gap-2 shadow-md transition-all hover:scale-105 hover:shadow-lg focus:outline-none"
                >
                  View Job <AiOutlineArrowRight className="w-5 h-5" />
                </button>
                <div className="text-gray-500 text-xs text-right">
                  <p className="font-medium">
                    <span className="text-gray-700">👥 Candidates:</span> {job.candidates || 0}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        {nextToken && (
          <div ref={loaderRef} className="text-center py-4 text-gray-500">
            Loading more...
          </div>
        )}
      </div>
    </div>
  );
};

export default SpotPlusCampaign;
